import axios from 'axios';
import authHeader from './auth-header';

const API_URL = import.meta.env.VITE_API_URL;

const getOrganization = () => axios.get(`${API_URL}/accounts/organization/`, { headers: authHeader() });
const createOrganization = (data) => axios.post(
  `${API_URL}/accounts/organization/`,
  data,
  { headers: authHeader() },
);
const getSubscription = () => axios.get(`${API_URL}/accounts/subscription/`, { headers: authHeader() });

// ⚠️ `organizations/<id>/` au pluriel, et PAS `organization/` au singulier :
// le singulier rend l'organisation de la personne connectée en lecture seule,
// le pluriel est la vue qui accepte l'écriture. Deux routes voisines, une
// seule modifiable — et se tromper rend un 405 sans rien expliquer.
//
// PATCH et non PUT : on n'envoie que les réglages touchés, donc un champ que
// cette version du front ne connaît pas encore n'est pas effacé au passage.
const updateOrganization = (id, data) => axios.patch(
  `${API_URL}/accounts/organizations/${id}/`,
  data,
  { headers: authHeader() },
);

const organizationService = {
  getOrganization,
  createOrganization,
  updateOrganization,
  getSubscription,
};

export default organizationService;
